jQuery(function($) {
    var $searchForms = $('.js-property-search');

    if (!$searchForms.length) {
        return;
    }

    var autocompleteAvailable = $.ui && $.ui.autocomplete;

    function escapeRegExp(value) {
        return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    if (autocompleteAvailable) {
        $.ui.autocomplete.prototype._renderItem = function(ul, item) {
            var value = String(item.value);
            var matcher = new RegExp(escapeRegExp(String(this.term)), 'gi');
            var content = document.createDocumentFragment();
            var lastIndex = 0;

            value.replace(matcher, function(match, offset) {
                content.appendChild(document.createTextNode(value.slice(lastIndex, offset)));

                var strong = document.createElement('strong');
                strong.textContent = match;
                content.appendChild(strong);

                lastIndex = offset + match.length;
                return match;
            });

            content.appendChild(document.createTextNode(value.slice(lastIndex)));

            return $('<li>').append($('<div>').append(content)).appendTo(ul);
        };
    }

    $searchForms.each(function() {
        var $form = $(this);
        var searchBase = String($form.attr('data-search-base') || '').replace(/\/?$/, '/');
        var ajaxUrl = $form.attr('data-ajax-url');

        $form.on('click', '.search-box-btn', function() {
            $form.find('.search-box-btn').removeClass('is-selected');
            $(this).addClass('is-selected');
        });

        $form.on('submit', function() {
            var action = $form.find('.search-box-btn.is-selected').data('value');
            var department = action === 'buy' ? 'for-sale' : 'to-rent';

            this.action = searchBase + department;
        });

        if (!autocompleteAvailable) {
            return;
        }

        $form.find('.location-input').autocomplete({
            source: function(request, response) {
                var $input = $(this.element);
                $input.addClass('is-loading');

                $.ajax({
                    url: ajaxUrl,
                    dataType: 'json',
                    data: {
                        action: 'search_locations',
                        term: request.term
                    },
                    success: function(data) {
                        response($.map(data, function(item) {
                            return {
                                label: item.label,
                                value: item.value
                            };
                        }));
                    },
                    error: function() {
                        response([]);
                    },
                    complete: function() {
                        $input.removeClass('is-loading');
                    }
                });
            },
            minLength: 2
        });
    });
});
